import { render, staticRenderFns } from "./billingStatement.vue?vue&type=template&id=18b6bd24&scoped=true&"
import script from "./billingStatement.vue?vue&type=script&lang=js&"
export * from "./billingStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b6bd24",
  null
  
)

export default component.exports